import { handleAjaxError } from "./handleAjaxError";
import { cloneGuestLocalHistoryToSessionToken } from "../helpers/guestLocalHistory";
import {
    hideChatGlobalLoader,
    showChatGlobalLoader,
} from "../components/chatGlobalLoader";

/**
 * @param action
 */
export function duplicateSession(action) {
    const handler = function (event) {
        event.preventDefault();

        let submitBtn = $(this);
        let chatForm = submitBtn.closest('.g-chatform');
        let sessionToken = chatForm.attr('data-session-token');

        if (submitBtn.hasClass('is-loading') || submitBtn.hasClass('is-disabled')) {
            return;
        }

        submitBtn.addClass('is-loading');
        showChatGlobalLoader(chatForm, {
            text: 'Duplicating',
        });

        jQuery.ajax({
            url: growtype_chat_ajax.url,
            type: 'post',
            data: {
                session_token: sessionToken,
                action: growtype_chat_ajax.session_duplicate_action,
                nonce: growtype_chat_ajax.nonce,
            },
            success: function (response) {
                if (response.success) {
                    const newSessionId = response?.data?.new_session_id || '';
                    if (newSessionId) {
                        cloneGuestLocalHistoryToSessionToken(chatForm, newSessionId);
                    }
                    const redirectUrl = response?.data?.redirect_url || window.location.href;
                    window.location.href = redirectUrl;
                } else {
                    hideChatGlobalLoader(chatForm);
                    handleAjaxError({ responseJSON: response }, submitBtn);
                }
            },
            error: function (response) {
                handleAjaxError(response, submitBtn);
                hideChatGlobalLoader(chatForm);
            }
        });
    };

    if (typeof action.off === 'function' && typeof action.on === 'function') {
        action.off('click.growtypeDuplicateSession').on('click.growtypeDuplicateSession', handler);
    } else {
        action.click(handler);
    }
}
